import { type IWidgetConfigurationSlot } from '@framework/engine/schema/widgets/repository/common/config-slots/IWidgetConfigurationSlot.ts';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import {
  IconBuildingBank,
  IconBuildingCommunity,
  IconLayersIntersect,
  IconMap,
  IconNumbers,
  IconPointer,
  IconPrinter,
  IconStack2,
  IconZoomQuestion,
} from '@tabler/icons-react';

/**
 * Slot delle card di configurazione del widget Mappa, nell'ordine di
 * presentazione (11..19, subito dopo "Impostazioni generali").
 */

export const MapPositionSlot: IWidgetConfigurationSlot = {
  key: 'map-position',
  title: 'Mappa',
  icon: <TbIcon icon={IconMap} />,
  description: 'Posizionamento iniziale della mappa: centro e livello di zoom.',
  order: 11,
};

export const MapSelectionSlot: IWidgetConfigurationSlot = {
  key: 'map-selection',
  title: 'Selezione',
  icon: <TbIcon icon={IconPointer} />,
  description:
    'Geometrie selezionabili, selezione multipla e distanza di buffer.',
  order: 12,
};

export const MapLabelingSlot: IWidgetConfigurationSlot = {
  key: 'map-labeling',
  title: 'Etichette Geometrie',
  icon: <TbIcon icon={IconNumbers} />,
  description: 'Etichette numerate delle geometrie disegnate sulla mappa.',
  order: 13,
};

export const MapGroupsAndLayersSlot: IWidgetConfigurationSlot = {
  key: 'map-groups-and-layers',
  title: 'Gruppi e Livelli',
  icon: <TbIcon icon={IconStack2} />,
  description: 'Gruppi e livelli cartografici mostrati sulla mappa.',
  order: 14,
};

export const MapIntersectionsSlot: IWidgetConfigurationSlot = {
  key: 'map-intersections',
  title: 'Intersezioni',
  icon: <TbIcon icon={IconLayersIntersect} />,
  description:
    'Intersezioni calcolate tra le geometrie selezionate e i livelli.',
  order: 15,
};

export const MapIdentifySlot: IWidgetConfigurationSlot = {
  key: 'map-identify',
  title: 'Interrogazione (Identify)',
  icon: <TbIcon icon={IconZoomQuestion} />,
  description: 'Interrogazione dei livelli al click sulla mappa (identify).',
  order: 16,
};

export const MapMunicipalityGroupSlot: IWidgetConfigurationSlot = {
  key: 'map-municipality-group',
  title: 'Gruppo Comuni',
  icon: <TbIcon icon={IconBuildingCommunity} />,
  description: 'Gruppo di comuni che filtra province e comuni disponibili.',
  order: 17,
};

export const MapCompetencesSlot: IWidgetConfigurationSlot = {
  key: 'map-competences',
  title: 'Competenze',
  icon: <TbIcon icon={IconBuildingBank} />,
  description: 'Determinazione delle competenze territoriali dalle geometrie.',
  order: 18,
};

export const MapPrintImagesSlot: IWidgetConfigurationSlot = {
  key: 'map-print-images',
  title: 'Immagini di Stampa',
  icon: <TbIcon icon={IconPrinter} />,
  description: 'Immagini della mappa generate per la stampa nel PDF.',
  order: 19,
};
